import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { api } from "@/lib/api";
import { AdminTitle } from "@/admin/AdminLayout";

const STATS = [["articles", "Articles"], ["pending", "Awaiting approval"], ["drafts", "My drafts"], ["readers", "Reader contributors"], ["sections", "Sections"], ["series", "Series"], ["books", "Books"], ["media", "Uploaded images"]];
const STAT_LINKS = { articles: "/admin/articles", pending: "/admin/submissions", drafts: "/admin/articles", readers: "/admin/submissions", sections: "/admin/sections", series: "/admin/series", books: "/admin/series", media: "/admin/settings" };

export default function AdminDashboard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)); }, []);
  return (
    <div data-testid="admin-dashboard">
      <AdminTitle eyebrow="Welcome back, Lorekeeper" title="The Scriptorium">
        <Link to="/admin/articles/new" data-testid="dashboard-new-article" className="btn-illum theme-flame"><Plus className="w-4 h-4" /> New article</Link>
        <Link to="/admin/series" data-testid="dashboard-new-book" className="btn-ghost-illum">Add a book</Link>
      </AdminTitle>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {STATS.map(([k, label]) => (
          <Link key={k} to={STAT_LINKS[k]} data-testid={`stat-${k}`} className="vellum p-5 lift block">
            <p className="font-display text-4xl text-[#991b1b]">{s ? s[k] : "–"}</p>
            <p className="font-heading text-[11px] uppercase tracking-[0.18em] mt-1 text-[#5e4a35]">{label}</p>
          </Link>
        ))}
      </div>
      <div className="vellum mt-10">
        <p className="font-heading font-bold px-6 py-4 border-b border-[#c9a227]/40">Recently edited</p>
        {s?.recent.map((a) => (
          <Link key={a.id} to={`/admin/articles/${a.id}`} data-testid={`recent-${a.slug}`} className="flex justify-between px-6 py-3 border-b border-[#c9a227]/20 hover:bg-[#c9a227]/10 transition-colors">
            <span className="font-heading">{a.title} {!a.published && <em className="text-xs text-[#991b1b] ml-2">draft</em>}</span>
            <span className="text-sm text-[#5e4a35]">{new Date(a.updated_at).toLocaleString()}</span>
          </Link>
        ))}
      </div>
      <div className="vellum mt-10 p-6 text-[15px] leading-relaxed">
        <p className="font-heading font-bold mb-2">Quick guide</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Create <b>Sections</b> for any new chamber of the codex (e.g. Battles, Artefacts). They appear in navigation automatically.</li>
          <li>Inside the article editor, select a word and press <b>Link to page</b> to cross-link it — or type <code>[[Page Title]]</code> / <code>[[Page Title|shown text]]</code>.</li>
          <li>Each article has fixed image slots: hero banner, drop-cap, infobox portrait/sigil and gallery.</li>
          <li>Books only appear on the site once you add them — set the Kindle link to make the cover clickable.</li>
        </ul>
      </div>
    </div>
  );
}
